export default __webpack_public_path__ + "static/media/bits-and-spaces-apps.28bf3bb2.png";